import React from "react";
import aboutImg from "../../../assets/image/abouthtrue.jpg"; // apni image ka path
import { Link } from "react-router-dom";

const Traditional = () => {
    return (
        <section className="py-16 bg-white">
            <div className="max-w-7xl mx-auto px-4 grid lg:grid-cols-2 gap-12 items-center">

                {/* LEFT IMAGE SECTION */}
                <div className="relative">
                    <img
                        src={aboutImg}
                        alt=" consultation"
                        className="w-full h-[400px] md:h-[580px] object-cover "
                    />

                    {/* EXPERIENCE CARD */}
                    {/* EXPERIENCE CARD */}
                    <div className="bg-white absolute w-72 overflow-hidden sm:w-80 p-2 shadow-xl -bottom-12 left-6 sm:left-20">
                        <div className="p-8 border-8 border-[#2d5883] overflow-hidden  relative">
                            <p className="text-[12px] text-[#222] uppercase tracking-wide relative z-[9] mb-3">
                                We have assisted over 1000 clients in connecting with top legal professionals
                            </p>

                            <div className="flex flex-col relative z-[9]">
                                <h2 className="text-[80px] font-[700] text-[#ec4e4f] leading-none my-3">
                                    6+
                                </h2>
                                <p className="text-sm text-gray-700 font-medium">
                                    Years Of  Experience
                                </p>
                            </div>


                            <div className="absolute right-[-80px] top-[-140px]  w-[171px] h-[171px] bg-[#edf6ff] rounded-full"></div>

                            <div className="absolute left-[-22px] bottom-[-20px]  w-[171px] h-[171px] bg-[#edf6ff] rounded-full"></div>

                        </div>
                    </div>

                </div>

                {/* RIGHT CONTENT SECTION */}
                <div className="mt-[30px] md:mt-[0]">
                    <p className="text-sm uppercase tracking-widest  font-[600] text-gray-500 mb-3 open-sans">
                        Who We Are


                    </p>

                    <h2 className="text-[30px] md:text-[48px] font-[700] text-gray-900 capitalize leading-tight mb-4">
                        Trinity Management Services Inc.

                    </h2>

                    <div className="flex gap-2 mb-6">
                        <div className="w-12 h-[3px] bg-[#ec4e4f]"></div>
                        <div className="w-1 h-[3px] bg-[#ec4e4f]"></div>
                        <div className="w-1 h-[3px] bg-[#ec4e4f]"></div>
                        <div className="w-1 h-[3px] bg-[#ec4e4f]"></div>
                    </div>

                    <p className="text-[20px] md:text-[24px] text-[#555555] mb-4">
                        Founded in January 2019, we have assisted over 1000 clients in connecting with top legal professionals. As
                        a trusted intermediary, we deliver seamless communication, expert case management, and efficient
                        solutions. With a nationwide presence in Canada, we specialize in making legal processes accessible,
                        transparent, and stress-free.


                    </p>



                    <Link to="/contact-us" className="inline-flex font-[600] text[18px] cabin items-center gap-2 bg-[#ec4e4f] text-white px-6 py-3 font-semibold rounded-[2px] hover:bg-red-600 transition">
                        Learn More
                        <span className="text-xl">→</span>
                    </Link>
                </div>

            </div>
        </section>
    );
};

export default Traditional;
